import { useFormContext } from 'react-hook-form';
import { Trans, useTranslation } from 'react-i18next';
import { Anchor, ButtonSubmit, Form } from '@anytag/shared-atoms';
import { THEME } from '@anytag/shared-constants';
import { PasswordField } from '@anytag/shared-molecules';
import { PasswordFormValues, PasswordFormKeys } from './types';

export const Template = () => {
  const { t } = useTranslation();
  const {
    watch,
    formState: { isSubmitting }
  } = useFormContext<PasswordFormValues>();

  const values = watch();

  return (
    <Form.Body className="px-10 py-12 shadow-none">
      <h1 css={{ fontSize: '20px', lineHeight: '100%', textAlign: 'center' }}>{t('Set a password and sign in')}</h1>
      <p css={{ fontSize: '14px', lineHeight: '140%', padding: '16px 0', textAlign: 'center' }}>
        <Trans i18nKey="SignUp.Description" components={{ br: <br /> }} />
      </p>

      <PasswordField<PasswordFormKeys> name="password" title={t('Password.Password')} dynamicError required />
      <PasswordField<PasswordFormKeys> name="passwordConfirm" title={t('Password.Confirm Password')} required />

      <ButtonSubmit
        loading={isSubmitting}
        title={t('Button.Sign Up')}
        className="mt-4 w-full"
        disabled={!values.password || !values.passwordConfirm}
      />

      <p css={{ marginTop: '32px', color: THEME.text.colors.gray.lv3, fontSize: '11px', lineHeight: '140%' }}>
        <Trans
          i18nKey="SignInConfirmation"
          components={{
            a1: <Anchor variant="blue" css={{ display: 'inline', lineHeight: 'inherit' }} to="/privacy" />,
            a2: <Anchor variant="blue" css={{ display: 'inline', lineHeight: 'inherit' }} to="/terms" />
          }}
        />
      </p>
    </Form.Body>
  );
};
